import {
    applySavedOrder as applyOrder,
    matchesName,
    readSavedOrder as readOrder,
    saveOrder as writeOrder,
} from 'utilities/helper/fundOrder'

export { normalizeFa } from 'utilities/helper/fundOrder'

/**
 * Ordering and search for «صندوق‌هایی که مدیر آن هستید».
 *
 * The merge rules, the localStorage handling and the Persian-folding search all
 * live in `utilities/helper/fundOrder` — the صندوق‌ها tab reorders its cards
 * with the same code. What is specific to *this* list, and stays here, is the
 * storage key and the ranking used before anyone has dragged anything.
 */

const STORAGE_KEY = 'home:managed-funds-order'

/**
 * The order used before anyone has dragged anything, and the tie-breaker for
 * funds the saved order has never seen.
 *
 * Funds you OWN come first, then ones you merely manage; within each, the
 * biggest fund first. Ownership outranks size because it is where the
 * decisions actually sit, and member count is the best proxy we have here for
 * "which of these matters most".
 *
 * The صندوق‌ها tab deliberately has no equivalent: it lists funds you are a
 * member of as well as ones you run, so there is no ranking that beats the
 * order the API already sends.
 */
export function defaultOrder(funds: MoneyPool[]): MoneyPool[] {
    const rank = (mp: MoneyPool) => (mp.poolship?.role === 'own' ? 0 : 1)
    return [...funds].sort((a, b) => {
        if (rank(a) !== rank(b)) return rank(a) - rank(b)
        return (b.active_members_count ?? 0) - (a.active_members_count ?? 0)
    })
}

export function readSavedOrder(): number[] {
    return readOrder(STORAGE_KEY)
}

export function saveOrder(ids: number[]): void {
    writeOrder(STORAGE_KEY, ids)
}

export function applySavedOrder(
    funds: MoneyPool[],
    savedIds: number[]
): MoneyPool[] {
    return applyOrder(funds, savedIds, defaultOrder)
}

export function matchesQuery(fund: MoneyPool, query: string): boolean {
    return matchesName(fund.name, query)
}
